import React from "react";
import Language from "../../language/language";
import { inject, observer } from "mobx-react";
import { $const, $util } from "../../../helper";
import { decryptRSA } from "../../../helper/crypto";
import moment from "moment";
import classnames from "classnames";
import { Tooltip, Spin, message } from "antd";
import agent from "../../../agent";
import JobInfo from "./jobInfo";

const formItemLabelList = [
  {
    label: "NAME",
    itemName: "name"
  },
  {
    label: "PHONE_NUMBER",
    itemName: "phoneNumber"
  },
  {
    label: "EMAIL",
    itemName: "email"
  },
  {
    label: "H_EDUCATION",
    itemName: "education"
  },
  {
    label: "H_SCHOOL",
    itemName: "school"
  },
  {
    label: "H_COLLEGE",
    itemName: "college"
  },
  {
    label: "H_MAJOR",
    itemName: "major"
  },
  {
    label: "H_START_TIME",
    itemName: "start"
  },
  {
    label: "H_END_TIME",
    itemName: "end"
  }
];

@inject("gameStore", "teamStore", "languageStore")
@observer
export default class GameFormHistory extends React.Component {
  state = {
    registrationStageStatusId: undefined,
    fileLoading: false,
    showAllHistoryForm: false
  };
  componentDidMount() {
    if (this.props.node.stageType === $const.STAGE_TYPE.JUDGE) {
      if (this.props.isMutiJudge) {
        return this.setState({
          registrationStageStatusId: this.props.registrationStageStatusId
        });
      }
      let registrationStageStatusId;
      let gameData = this.props.gameData;
      gameData &&
        gameData.registrationStageStatuses &&
        gameData.registrationStageStatuses.nodes &&
        gameData.registrationStageStatuses.nodes.forEach(node => {
          if (node.stageId === this.props.stageId) {
            registrationStageStatusId = node.id;
          }
        });
      if (registrationStageStatusId) {
        this.props.teamStore
          .getQuizConfig(registrationStageStatusId, this.props.stageId)
          .then(() => {
            this.setState({
              registrationStageStatusId: registrationStageStatusId
            });
          });
      }
    }
  }

  getUploadUrl = (object_key, fileName) => {
    this.setState({
      fileLoading: true
    });
    let that = this;
    agent.Common.getV2UploadUrl(object_key)
      .then(res => {
        if (res.status === 0 && res.result && res.result.url) {
          if (Object.prototype.hasOwnProperty.call(res.result, "parma")) {
            const urlByDecryptRSA = decryptRSA(res.result.url);
            if (!urlByDecryptRSA) {
              message.error("文件下载失败，请稍后重试。");
              return Promise.reject("文件解密失败");
            }
            const downloadUrl = `${urlByDecryptRSA}${res.result.parma}`;
            $util.downloadFile(downloadUrl, fileName, res.result.headers, () => {
              that.setState({
                fileLoading: false
              });
            });
          } else {
            // 兼容服务端未发布上线，老接口无parma字段
            $util.downloadFile(res.result.url, fileName, res.result.headers, () => {
              that.setState({
                fileLoading: false
              });
            });
          }
        } else {
          that.setState({
            fileLoading: false
          });
        }
      })
      .catch(err => {
        console.log(err);
        that.setState({
          fileLoading: false
        });
      });
  };

  renderUploadInput = (input, index, item) => {
    let reg = /^(https|http):\/\/terra-[a-z-]*\..*\.(amazonaws|aliyuncs)\.com\//g;
    // 新上传平台处理
    if (reg.test(input.value)) {
      // 兼容老的上传数据
      let domain = input.value.match(reg)[0];
      let objectKey = input.value.replace(domain, "").match(/[a-z0-9]*\/([a-z0-9]|-)*/g)[0];
      let fileName = input.value.replace(domain, "").replace(objectKey + ".", "");
      return (
        <div
          className="my-inputs__item my-inputs__item--blue"
          key={`${this.props.formId}-${item.num}-${input.keyNameUuid}${index}`}
        >
          <Tooltip title={fileName}>
            <a target="_blank" onClick={this.getUploadUrl.bind(this, objectKey, fileName)}>
              {fileName}
            </a>
          </Tooltip>
        </div>
      );
    }
    // 上传组件特殊处理
    if (input.value.indexOf("participation_materials") > -1) {
      // 兼容老的上传数据
      let fileUrl = decodeURIComponent(input.value).split("/");
      let fileName = fileUrl[fileUrl.length - 1].split("-");
      return (
        <div
          className="my-inputs__item my-inputs__item--blue"
          key={`${this.props.formId}-${item.num}-${input.keyNameUuid}${index}`}
        >
          <Tooltip title={fileName.slice(1, fileName.length).join("-")}>
            <a target="_blank" href={input.value}>
              {fileName.slice(1, fileName.length)
                ? fileName.slice(1, fileName.length).join("-")
                : fileUrl[fileUrl.length - 1]}
            </a>
          </Tooltip>
        </div>
      );
    }
    let url = input.value.split("/");
    let name = url[url.length - 1].split("-");
    return (
      <div key={`${this.props.formId}-${item.num}-${input.keyNameUuid}${index}`}>
        <Tooltip title={name.slice(4, name.length)}>
          <a
            className="my-inputs__item my-inputs__item--blue"
            target="_blank"
            href={`${url.slice(0, url.length - 1).join("/")}/${encodeURIComponent(
              url[url.length - 1]
            )}`}
          >
            {name.slice(4, name.length)
              ? name.slice(4, name.length).toString()
              : url[url.length - 1]}
          </a>
        </Tooltip>
      </div>
    );
  };

  renderMyInputs = (myinputs, item) => {
    const lang = this.props.languageStore.lang;

    return (
      <div className="my-inputs">
        {myinputs.length > 0 &&
          myinputs.map((input, index) => {
            if (
              input.input &&
              input.input.viewType === $const.INPUTVIEWTYPE.UPLOAD &&
              input.value
            ) {
              return this.renderUploadInput(input, index, item);
            }
            if (input.input.viewType === $const.INPUTVIEWTYPE.TIME_RESERVATION) {
              return null;
            }
            if (
              input.input &&
              $const.OPTIONAL_COMPONENTS.includes(input.input.viewType) &&
              input.goptions &&
              input.value
            ) {
              // radio 组件特殊处理 // select 特殊处理
              let option = input.goptions.find(item => {
                return item.valueString === input.value;
              });
              let content = `${input.labelUuidI18n[lang]}:  ${option.contentUuidI18n &&
                option.contentUuidI18n[lang]}`;
              return (
                <div
                  className="my-inputs__item"
                  key={`${this.props.formId}-${item.num}-${input.keyNameUuid}${index}`}
                >
                  <Tooltip title={content}>{content}</Tooltip>
                </div>
              );
            }
            if (input.input.viewType === $const.INPUTVIEWTYPE.UPLOAD_DOCKER_FILE && input.value) {
              return (
                <Tooltip className="my-inputs__item" title={input.value}>
                  {input.value}
                </Tooltip>
              );
            }
            if (input.input.viewType === $const.INPUTVIEWTYPE.PERSONAL_INFO && input.value) {
              const valueObj = JSON.parse(input.value);

              return formItemLabelList.map((item, idx) => {
                const info = (
                  <span>
                    <Language resource={item.label} />：{`${valueObj[item.itemName]}`}
                  </span>
                );
                return (
                  <div
                    className="my-inputs__item"
                    key={`${this.props.formId}-${item.num}-${input.keyNameUuid}${index}${idx}`}
                  >
                    <Tooltip title={info}>{info}</Tooltip>
                  </div>
                );
              });
            }

            if (input.input.viewType === $const.INPUTVIEWTYPE.CHOOSE_JOB && input.value) {
              return <JobInfo input={input} uuid={input.keyNameUuid} />;
            }
            return (
              <div
                className="my-inputs__item"
                key={`${this.props.formId}-${item.num}-${input.keyNameUuid}${index}`}
              >
                <Tooltip title={input.value}>{input.value ? input.value : ""}</Tooltip>
              </div>
            );
          })}
      </div>
    );
  };

  getFixedText = () => {
    if (this.state.registrationStageStatusId && this.props.teamStore.quiz.id !== 0) {
      const config =
        this.props.teamStore.quiz[this.state.registrationStageStatusId] &&
        this.props.teamStore.quiz[this.state.registrationStageStatusId].config;
      if (config && config.scoreRule === $const.QUIZ_SCORE_RULE.LAST) {
        return <Language resource="JUAGE_SCORE_LAST" />;
      }
      if (config && config.scoreRule === $const.QUIZ_SCORE_RULE.HIGHEST) {
        return <Language resource="JUAGE_SCORE_HIGHEST" />;
      }
    }
    return null;
  };
  renderMutiJudgeHistory = notCurrentStage => {
    let registrationStageStatusId = this.props.registrationStageStatusId;
    if (notCurrentStage) {
      registrationStageStatusId = this.state.registrationStageStatusId;
    }
    if (
      this.props.teamStore.quiz &&
      this.props.teamStore.quiz[registrationStageStatusId] &&
      this.props.teamStore.quiz[registrationStageStatusId].history
    ) {
      const history = this.props.teamStore.quiz[registrationStageStatusId].history;
      const _isAuto = this.props.teamStore.quiz[registrationStageStatusId].isAuto;
      const score = history[0] && history[0].quizOfUser && history[0].quizOfUser.score;
      const submittedAt = history[0] && history[0].quizOfUser && history[0].quizOfUser.submittedAt;
      const status = history[0] && history[0].status;
      // 只有通过或者失败，才显示下面文案
      const lang = this.props.languageStore.lang;
      const scoreLabel = this.props.languageStore.getResource(lang, "MUTI_SCORE");
      const submitTimeLabel = this.props.languageStore.getResource(lang, "MUTI_SUBMIT_TIME");
      const statusLabel = this.props.languageStore.getResource(lang, "MUTI_STATUS");
      let statusValue = undefined;
      if (status && status !== "pending") {
        statusValue = this.props.languageStore.getResource(lang, status.toUpperCase());
      } else if (status && status === "pending" && _isAuto) {
        statusValue = this.props.languageStore.getResource(lang, "MUTI_PENDING_STATUS");
      }
      const list = [
        {
          label: scoreLabel,
          value: score
        },
        {
          label: submitTimeLabel,
          value: submittedAt && moment(submittedAt).format("YYYY-MM-DD HH:mm:ss")
        },
        {
          label: statusLabel,
          value: statusValue
        }
      ];
      return (
        ((score !== null) & (score !== undefined) ||
          submittedAt ||
          status === "passed" ||
          status === "failed") && (
          <div className="form-history history-judge">
            <div className="form-list">
              <ul>
                <li className="form-item">
                  {list.map(item => {
                    return (item.value !== null) & (item.value !== undefined) ? (
                      <div
                        className="feedback"
                        key={`${item.label}-${item.value}-${this.props.registrationStageStatusId}`}
                      >
                        <Tooltip title={item.label}>
                          {`${item.label}: `}
                          <span className="content">{item.value}</span>
                        </Tooltip>
                      </div>
                    ) : null;
                  })}
                </li>
              </ul>
            </div>
          </div>
        )
      );
    }
    return null;
  };
  renderJudgeHistory = (history, formId) => {
    let length = history.length;
    let content = history[length - 1];
    const lang = this.props.languageStore.lang;
    let tip = this.props.languageStore.getResource(lang, "EXAM_STATUS_TIP");
    const isRm2019 = this.props.myFlow && this.props.myFlow.eventId === "6";

    return (
      <div className="form-history history-judge">
        <div className="form-list">
          <ul>
            <li className="form-item">
              {isRm2019 ? (
                <div className="date">
                  <Language resource="LAST_TIME" />:
                  <span className="content">
                    {moment(content.createdAt).format("YYYY/MM/DD HH:mm:ss")}
                  </span>
                </div>
              ) : null}

              {content.cms.map(feedback => {
                let value = feedback.value;
                if (moment(value, moment.ISO_8601, true).isValid()) {
                  value = moment(value).format("YYYY/MM/DD HH:mm:ss");
                }
                return (
                  <div className="feedback" key={`${formId}${content.num}${feedback.keyNameUuid}`}>
                    <Tooltip title={value}>
                      {`${
                        feedback.labelUuidI18n && feedback.labelUuidI18n[lang]
                          ? feedback.labelUuidI18n[lang] + ": "
                          : ""
                      }`}
                      <span className="content">{value}</span>
                    </Tooltip>
                  </div>
                );
              })}
              {isRm2019 ? (
                <div className="feedback" key="EXAM_STATUS">
                  <Tooltip title={tip}>
                    <p>
                      <Language resource="EXAM_STATUS">
                        :<Language resource="EXAM_STATUS_TIP" className="content"></Language>
                      </Language>
                    </p>
                  </Tooltip>
                </div>
              ) : (
                this.getFixedText()
              )}
            </li>
          </ul>
        </div>
      </div>
    );
  };

  formatMeeting(option) {
    if (!option || !option.beginAt || !option.endAt) return <Language resource="ABNORMAL_DATA" />;
    return `${moment(option.beginAt).format("HH:mm")} ~ ${moment(option.endAt).format("HH:mm")}`;
  }

  renderMeetingHistory() {
    const { myMeeting } = this.props.node.meeting;
    return (
      <div className="form-history">
        <div className="sub-title">
          <Language resource="UPLOAD_HISTORY" />
        </div>

        <div className="form-list">
          <ul>
            <li>
              <div className="my-inputs">
                <span>
                  <Language resource="INTERVIEW_TIME" />:{" "}
                  {myMeeting &&
                    myMeeting.meeting &&
                    `${myMeeting.meeting.date} ${this.formatMeeting(myMeeting.meeting)}`}
                </span>
              </div>
              <div className="date">
                {myMeeting &&
                  myMeeting.createdAt &&
                  moment(myMeeting.createdAt).format("YYYY-MM-DD")}
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  }
  renderTimeMeetingHistory() {
    const { myMeeting } = this.props.node.meeting;
    return (
      <div className="form-history">
        <div className="sub-title">
          <Language resource="UPLOAD_HISTORY" />
        </div>

        <div className="form-list">
          <ul>
            <li>
              <div className="my-inputs">
                <span>
                  <Language resource="RESERVATION_TIME" />:{" "}
                  {myMeeting &&
                    myMeeting.meeting &&
                    `${myMeeting.meeting.date} ${this.formatMeeting(myMeeting.meeting)}`}
                </span>
              </div>
              <div className="date">
                {myMeeting &&
                  myMeeting.createdAt &&
                  moment(myMeeting.createdAt).format("YYYY-MM-DD")}
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  }

  renderDockerPerformanceFeedback = feedback => {
    const { value } = feedback;
    try {
      const feedbackInfoList = JSON.parse(value);
      if (Array.isArray(feedbackInfoList) && feedbackInfoList.length) {
        return (
          <div className="feedback feedback-docker-per-feedback">
            {feedbackInfoList.map(item => {
              const { key, title, unit, value } = item;
              return (
                <div>
                  {key === "feedbackDoc" ? (
                    <div className="feedback-docker-per-feedback__content--item">
                      {`${title}: `}
                      <Tooltip key={key} title={value}>
                        <a target="__blank" href={value}>
                          {"日志链接"}
                        </a>
                      </Tooltip>
                    </div>
                  ) : (
                    <div key={key}>{`${title}: ${value} ${unit && unit}`}</div>
                  )}
                </div>
              );
            })}
          </div>
        );
      }
    } catch (error) {
      return <div />;
    }
    return <div />;
  };

  renderDockerProgressStatus = feedback => {
    const { labelUuidI18n, value } = feedback;
    return (
      <div className="feedback_docker">
        {`${labelUuidI18n[this.props.languageStore.lang]}: ${value}`}
      </div>
    );
  };

  changeShowAllHistoryForm = () => {
    this.setState({
      showAllHistoryForm: !this.state.showAllHistoryForm
    });
  };

  // 提交历史倒序排序
  sortHistoryByTime = history => {
    if (Array.isArray(history) && history.length > 0) {
      return history.sort((itemA, itemB) => {
        const createdAtA = itemA.createdAt;
        const createdAtB = itemB.createdAt;
        return new Date(createdAtB).getTime() - new Date(createdAtA).getTime();
      });
    }
    return [];
  };

  render() {
    const formId = this.props.formId;
    const hasMoreHistory = this.props.history && this.props.history.length > 3;
    const sortHistoryData = this.sortHistoryByTime(this.props.history);
    // 提交历史是否超过3条
    // 是否展示所有提交历史
    const showAllHistoryForm = this.state.showAllHistoryForm;
    const history = showAllHistoryForm ? sortHistoryData : sortHistoryData.slice(0, 3);
    const nodeType = this.props.node.stageType;
    if (
      this.state.registrationStageStatusId &&
      nodeType === $const.STAGE_TYPE.JUDGE &&
      this.props.isMutiJudge
    ) {
      // 多人测评历史记录展示
      return this.renderMutiJudgeHistory();
    }
    if (nodeType !== $const.STAGE_TYPE.MEETING && (!formId || history.length < 1)) {
      return null;
    }
    const lang = this.props.languageStore.lang;
    // 当目前所处的环节不是测评环节，并且测评环节的状态是成功或者失败，兼容多人测评
    const _config =
      this.props.teamStore.quiz[this.state.registrationStageStatusId] &&
      this.props.teamStore.quiz[this.state.registrationStageStatusId].config;
    if (this.state.registrationStageStatusId && _config && _config.forMultiPeople) {
      return this.renderMutiJudgeHistory(true);
    }
    if (nodeType === $const.STAGE_TYPE.JUDGE) {
      // 测评环节的历史记录展示
      return this.renderJudgeHistory(history, formId);
    } else if (nodeType === $const.STAGE_TYPE.MEETING) {
      // 面试预约环节的历史记录展示
      return this.renderMeetingHistory();
    }
    return (
      <div className="form-history">
        {this.props.node.meeting &&
          (this.props.node.meeting.meetings.length > 0 ? (
            this.renderTimeMeetingHistory()
          ) : (
            <div className="sub-title">
              <Language resource="UPLOAD_HISTORY" />
            </div>
          ))}
        <div className="form-list">
          <ul>
            {history.map((item, index) => {
              return (
                <li
                  className={classnames({
                    "form-item": true,
                    "form-item-only-one-feedback": item.cms.length === 1
                  })}
                  key={`history-${formId}${item.num}`}
                >
                  <div className="date">
                    <Language resource="MUTI_SUBMIT_TIME" />：
                    {moment(new Date(item.createdAt)).format("YYYY.MM.DD HH:mm:ss")}
                  </div>
                  {this.renderMyInputs(item.www, item)}
                  {item.cms.map(feedback => {
                    if (
                      feedback.input &&
                      $const.OPTIONAL_COMPONENTS.includes(feedback.input.viewType) &&
                      feedback.goptions &&
                      feedback.value
                    ) {
                      // radio 组件特殊处理 // select 特殊处理
                      let option = feedback.goptions.find(item => {
                        return item.valueString === feedback.value;
                      });
                      if (!option) {
                        return <div className="feedback"></div>;
                      }
                      return (
                        <div
                          className="feedback"
                          key={`${this.props.formId}-${feedback.keyNameUuid}`}
                        >
                          {`${feedback.labelUuidI18n[lang]}:  ${option.contentUuidI18n &&
                            option.contentUuidI18n[lang]}`}
                        </div>
                      );
                    }
                    if (
                      feedback.input &&
                      feedback.input.viewType ===
                        $const.INPUTVIEWTYPE.DOCKER_PERFORMANCE_FEEDBACK &&
                      feedback.goptions &&
                      feedback.value
                    ) {
                      // docker镜像执行结果反馈
                      return this.renderDockerPerformanceFeedback(feedback);
                    }
                    if (
                      feedback.input &&
                      feedback.input.viewType ===
                        $const.INPUTVIEWTYPE.FEEDBACK_DOCKER_PROGRESS_STATUS &&
                      feedback.goptions &&
                      feedback.value
                    ) {
                      // docker程序执行队列状态
                      return this.renderDockerProgressStatus(feedback);
                    }
                    return (
                      <div className="feedback" key={`${formId}${item.num}${feedback.keyNameUuid}`}>
                        <Tooltip title={feedback.value}>
                          {`${
                            feedback.labelUuidI18n && feedback.labelUuidI18n[lang]
                              ? feedback.labelUuidI18n[lang] + ": "
                              : ""
                          }`}
                          <span className="content">{feedback.value}</span>
                        </Tooltip>
                      </div>
                    );
                  })}
                </li>
              );
            })}
          </ul>
          {showAllHistoryForm
            ? hasMoreHistory && (
                <div
                  className="formHistory__showAll--close"
                  onClick={this.changeShowAllHistoryForm}
                >
                  <Language resource="CLICK_TO_CLOSE" />
                </div>
              )
            : hasMoreHistory && (
                <div className="formHistory__showAll--open" onClick={this.changeShowAllHistoryForm}>
                  <Language resource="CLICK_TO_LOAD_MORE" />
                </div>
              )}
        </div>
        {this.state.fileLoading ? (
          <div className="file-loading">
            <Spin />
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/formList/gameFormHistory/index.js